<template>
    <button type="button" class="btn btn-danger mb-0 px-3 me-2 " @click="showQuestion()" :disabled="disabled">
        <fa-icon v-if="contentMode == 'icon' || contentMode == 'text-icon'" icon="fas fa-trash-alt"></fa-icon>
        <template  v-if="contentMode == 'text' || contentMode == 'text-icon'" >
            حذف
        </template>
    </button>
</template>

<script>
    import BaseService from "@/services/Base-service";

    export default {
        name: "DeleteButton",
        props: {
            url: {
                type: String,
                default: "",
            },
            contentMode: {
                type: String,
                default : 'icon'
            },
            question: {
                type: String,
                default: "آیا برای حذف مورد انتخاب شده اطمینان دارید؟",
            },
            getReason: {
                type: Boolean,
                default: true,
            },
            reasonIsRequired: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        emits: ["fnCallback"],
        data() {
            return {
                deleteReason : ''
            };
        },
        components: {
        },
        methods: {
            showQuestion() {
                let vm = this;
                this.$swal.fire({
                    title: 'تایید حذف',
                    html: `<div>${this.question}</div>` + (this.getReason ? `<div class="mt-3">لطفا دلیل حذف را وارد نمایید :</div>` : ''),
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'انصراف',
                    confirmButtonText: 'بله، حذف شود',
                    reverseButtons: true,
                    input: 'textarea',
                    inputClass: "text-danger",
                    inputValue: "",
                    //inputValidator: (value) => {
                    //    debugger
                    //    alert('asdf');
                    //},
                    preConfirm: (value) => {
                        if (vm.reasonIsRequired && vm.getReason && (!value || value.trim() == '')) {
                            this.$swal.showValidationMessage('<i class="fa fa-info-circle"></i> لطفا دلیل حذف را وارد نمایید');
                        }
                        else {
                            vm.deleteReason = value;
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        if (vm.url && vm.url.length > 0) {
                            BaseService.get(
                                vm.removeTrailingSlash(vm.url) + (vm.getReason && vm.deleteReason ? '/' + vm.deleteReason : '' )
                            ).then(response => {
                                let result = response.data;

                                if (!result.isSuccess) {
                                    vm.$toast.error(result.message);
                                }
                                else {
                                    vm.$toast.success(result.message);
                                    vm.$emit("fn-callback", true);
                                }
                            })
                                .catch(e => {
                                    console.log(e);
                                });
                        }
                        else {
                            vm.$emit("fn-callback", true);
                        }
                    }
                    else {
                        vm.$emit("fn-callback", false);
                    }
                })

            },
            removeTrailingSlash(str) {
                return str.replace(/\/+$/, '');
            }
        },
        created() { },
        computed: {
        }
    };

</script>